import { cn } from "@/lib/utils";

/** Flat console select trigger inside editor/content surfaces (no float shadow). */
export const EDITOR_CONTENT_SELECT_TRIGGER_CLASS = cn(
  "border-(--console-border-input)! shadow-none!",
);

/** Flat console text input inside editor/content surfaces (no float shadow). */
export const EDITOR_CONTENT_INPUT_CLASS = cn(
  "border-(--console-border-input)! shadow-none!",
);

/** Collapsible subsection label chrome in editor section lists. */
export const EDITOR_COLLAPSIBLE_PANEL_LABEL_CLASS = cn(
  "mt-0 p-[3px] text-(--console-text-label)",
);

/** Collapsible subsection container spacing in editor section lists. */
export const EDITOR_COLLAPSIBLE_PANEL_CONTAINER_CLASS =
  "m-0 mb-(--console-space-block-gap)";
